export default "__VITE_ASSET__BFPd6eu2__"